(function () {
  // Champ photo de custom-kits : injecte par l app Uploadery APRES le chargement, sans intitule,
  // sans accept, et refuse le seul bouton d achat visible (la barre collante) en silence complet
  // sur Safari iOS, ou form.reportValidity() ne peint rien. Mesure du 25/08 : tap sans photo =
  // panier 0, page qui saute a 726, zero message. Ce fichier est le SEUL proprietaire de
  // l interception : abn-upload-guard.js mourait ligne 3 (pas de boucle d attente) et
  // abn-photo-natif.js sort tout de suite parce que la barre collante est hors formulaire.

  /* Textes par langue de la vitrine. Langue lue sur Shopify.locale, puis <html lang>,
     et anglais par defaut. */
  var TXT = {"en":{"label":"Your photo","help":"JPG, PNG or HEIC. Required, this is the picture your canvas is printed from.","error":"Pick your photo first. Your kit is printed from it.","attached":"Photo attached: {name}","chooseFirst":"Choose the photo you'd like painted before adding to cart.","tooBig":"That file is {mb} MB. The limit is 20 MB, please pick a smaller one."},"fr":{"label":"Votre photo","help":"JPG, PNG ou HEIC. Obligatoire, c'est l'image à partir de laquelle votre toile est imprimée.","error":"Choisissez d'abord votre photo. C'est à partir d'elle que votre kit est imprimé.","attached":"Photo jointe : {name}","chooseFirst":"Choisissez la photo que vous souhaitez faire peindre avant de l'ajouter au panier.","tooBig":"Ce fichier fait {mb} Mo. La limite est de 20 Mo, choisissez-en un plus léger."},"de":{"label":"Dein Foto","help":"JPG, PNG oder HEIC. Erforderlich, nach diesem Bild wird deine Leinwand gedruckt.","error":"Wähle zuerst dein Foto aus. Danach wird dein Set gedruckt.","attached":"Foto angehängt: {name}","chooseFirst":"Wähle das Foto aus, das gemalt werden soll, bevor du es in den Warenkorb legst.","tooBig":"Diese Datei ist {mb} MB groß. Das Limit liegt bei 20 MB, bitte wähle eine kleinere."},"es":{"label":"Tu foto","help":"JPG, PNG o HEIC. Obligatorio, es la imagen a partir de la cual se imprime tu lienzo.","error":"Elige primero tu foto. Tu kit se imprime a partir de ella.","attached":"Foto adjunta: {name}","chooseFirst":"Elige la foto que quieras que pintemos antes de añadir al carrito.","tooBig":"Este archivo pesa {mb} MB. El límite es de 20 MB, elige uno más pequeño."},"it":{"label":"La tua foto","help":"JPG, PNG o HEIC. Obbligatorio, è l'immagine da cui viene stampata la tua tela.","error":"Scegli prima la tua foto. Il tuo kit viene stampato a partire da questa.","attached":"Foto allegata: {name}","chooseFirst":"Scegli la foto che vuoi far dipingere prima di aggiungere al carrello.","tooBig":"Questo file pesa {mb} MB. Il limite è 20 MB, scegline uno più leggero."},"ja":{"label":"お客様の写真","help":"JPG、PNGまたはHEIC形式。必須項目で、この写真をもとにキャンバスを印刷します。","error":"先に写真を選択してください。この写真をもとにキットを印刷します。","attached":"添付された写真：{name}","chooseFirst":"カートに追加する前に、描いてほしい写真を選択してください。","tooBig":"このファイルは{mb}MBです。上限は20MBですので、もう少し小さい写真をお選びください。"},"ko":{"label":"고객님의 사진","help":"JPG, PNG 또는 HEIC. 필수 항목이며, 이 사진을 바탕으로 캔버스를 인쇄합니다.","error":"먼저 사진을 선택해 주세요. 이 사진을 바탕으로 키트를 인쇄합니다.","attached":"첨부된 사진: {name}","chooseFirst":"장바구니에 담기 전에 그려드릴 사진을 선택해 주세요.","tooBig":"이 파일은 {mb}MB입니다. 제한은 20MB이니 더 작은 사진을 선택해 주세요."},"lt":{"label":"Jūsų nuotrauka","help":"JPG, PNG arba HEIC. Būtina, pagal šią nuotrauką bus atspausdinta jūsų drobė.","error":"Pirmiausia pasirinkite nuotrauką. Pagal ją bus atspausdintas jūsų rinkinys.","attached":"Pridėta nuotrauka: {name}","chooseFirst":"Prieš pridėdami į krepšelį, pasirinkite nuotrauką, kurią norite, kad nutapytume.","tooBig":"Šis failas yra {mb} MB. Riba yra 20 MB, pasirinkite mažesnį."},"nb":{"label":"Bildet ditt","help":"JPG, PNG eller HEIC. Påkrevd, dette er bildet lerretet ditt trykkes etter.","error":"Velg bildet ditt først. Settet ditt trykkes etter det.","attached":"Bilde lagt ved: {name}","chooseFirst":"Velg bildet du vil ha malt, før du legger i handlekurven.","tooBig":"Denne filen er {mb} MB. Grensen er 20 MB, velg et mindre bilde."},"pl":{"label":"Twoje zdjęcie","help":"JPG, PNG lub HEIC. Wymagane, na podstawie tego zdjęcia drukujemy Twoje płótno.","error":"Najpierw wybierz swoje zdjęcie. Na jego podstawie drukujemy Twój zestaw.","attached":"Załączone zdjęcie: {name}","chooseFirst":"Wybierz zdjęcie, które chcesz mieć namalowane, zanim dodasz do koszyka.","tooBig":"Ten plik ma {mb} MB. Limit to 20 MB, wybierz mniejszy."},"sv":{"label":"Ditt foto","help":"JPG, PNG eller HEIC. Krävs, det är den här bilden din duk trycks efter.","error":"Välj ditt foto först. Ditt kit trycks efter det.","attached":"Foto bifogat: {name}","chooseFirst":"Välj fotot du vill ha målat innan du lägger i varukorgen.","tooBig":"Den här filen är {mb} MB. Gränsen är 20 MB, välj en mindre."},"zh-TW":{"label":"您的照片","help":"JPG、PNG或HEIC格式。必填，我們會依據這張照片印製您的畫布。","error":"請先選擇您的照片。我們會依據這張照片印製您的套組。","attached":"已附加照片：{name}","chooseFirst":"加入購物車前，請先選擇您想要繪製的照片。","tooBig":"這個檔案有 {mb} MB。上限為 20 MB，請選擇較小的照片。"}};

  var TXT_ENVOI = {"en":["Preparing your photo…","Uploading your photo ({mb} MB). Keep this page open, it can take up to a minute on mobile data."],"fr":["Préparation de votre photo…","Envoi de votre photo ({mb} Mo). Gardez cette page ouverte, cela peut prendre jusqu'à une minute en données mobiles."],"de":["Dein Foto wird vorbereitet…","Dein Foto wird hochgeladen ({mb} MB). Lass diese Seite geöffnet, mit mobilen Daten kann das bis zu einer Minute dauern."],"es":["Preparando tu foto…","Subiendo tu foto ({mb} MB). Mantén esta página abierta, con datos móviles puede tardar hasta un minuto."],"it":["Preparazione della foto…","Caricamento della foto ({mb} MB). Tieni aperta questa pagina, con i dati mobili può richiedere fino a un minuto."],"ja":["写真を準備しています…","写真をアップロードしています（{mb} MB）。モバイル通信では最大1分ほどかかる場合があります。このページを開いたままにしてください。"],"ko":["사진을 준비하는 중입니다…","사진을 업로드하는 중입니다({mb}MB). 모바일 데이터에서는 최대 1분 정도 걸릴 수 있으니 이 페이지를 닫지 마세요."],"lt":["Ruošiama jūsų nuotrauka…","Įkeliama jūsų nuotrauka ({mb} MB). Neuždarykite šio puslapio, naudojant mobiliuosius duomenis tai gali užtrukti iki minutės."],"nb":["Klargjør bildet ditt…","Laster opp bildet ditt ({mb} MB). La siden være åpen, med mobildata kan det ta opptil ett minutt."],"pl":["Przygotowujemy Twoje zdjęcie…","Wysyłanie zdjęcia ({mb} MB). Nie zamykaj tej strony, przy danych mobilnych może to potrwać do minuty."],"sv":["Förbereder ditt foto…","Laddar upp ditt foto ({mb} MB). Låt sidan vara öppen, med mobildata kan det ta upp till en minut."],"zh-TW":["正在準備您的照片…","正在上傳您的照片（{mb} MB）。使用行動數據時最多可能需要一分鐘，請勿關閉此頁面。"]};
  for (var kl in TXT_ENVOI) if (TXT[kl]) { TXT[kl].prep = TXT_ENVOI[kl][0]; TXT[kl].sending = TXT_ENVOI[kl][1]; }
  function langue() {
    var l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    if (TXT[l]) return l;
    var bas = String(l).toLowerCase();
    for (var k in TXT) if (k.toLowerCase() === bas) return k;
    if (/^zh/.test(bas)) return 'zh-TW';
    bas = bas.split('-')[0];
    return TXT[bas] ? bas : 'en';
  }
  function t(cle, v) {
    var s = (TXT[langue()] || {})[cle] || TXT.en[cle] || '';
    return s.replace(/\{(\w+)\}/g, function (m, n) { return v && v[n] != null ? v[n] : m; });
  }
  /* Le libelle du bouton change avec la langue : on le reconnait d'abord a sa place. */
  var ACHAT = '[name="add"], #abn-msticky-btn, #sticky-bar-button, .shopify-payment-button__button';
  function estAchat(b) {
    if (!b || !b.matches) return false;
    if (b.matches(ACHAT)) return true;
    if (b.type === 'submit' && b.closest('form[action*="/cart/add"]')) return true;
    var s = (b.innerText || b.value || '') + ' ' + (b.getAttribute('aria-label') || '');
    return /add to cart|buy it now|add to bag|ajouter au panier/i.test(s);
  }
  var LIBELLE = t('label');
  var AIDE = t('help');
  var ERREUR = t('error');
  var FORMATS = "image/jpeg,image/png,image/webp,.heic,.heif";
  // Plafond d envoi Shopify sur une propriete de ligne. Ce controle vivait dans le <script>
  // de snippets/abn-photo-upload.liquid ; le snippet est redevenu du balisage seul le 20/09,
  // il est donc remonte ici, ou il beneficie des 12 langues au lieu d un message anglais.
  var MAX_OCTETS = 20 * 1024 * 1024;


  // Plainte clients d octobre : « le site bug quand on envoie la photo ». Le panier recevait bien
  // le fichier, mais une photo de telephone (4 a 14 Mo, mesure 14 Mo = 10 s sur fibre) part en
  // entier dans le POST /cart/add, et en 4G le bouton tourne une minute sans rien dire. On reduit
  // la photo dans le navigateur avant l envoi : 3600 px sur le grand cote (180 dpi en 50 cm),
  // JPEG 0,9. En cas d echec (HEIC sous Chrome, DataTransfer absent), le fichier d origine part.
  var COTE_MAX = 3600, SEUIL = 2.5 * 1024 * 1024, enPrep = false;
  function decoder(f) {
    if (window.createImageBitmap) {
      return createImageBitmap(f, { imageOrientation: "from-image" }).catch(function () { return createImageBitmap(f); });
    }
    return new Promise(function (ok, ko) {
      var u = URL.createObjectURL(f), im = new Image();
      im.onload = function () { ok(im); };
      im.onerror = function () { URL.revokeObjectURL(u); ko(new Error("decode")); };
      im.src = u;
    });
  }
  function alleger(champ, f) {
    if (!f || f.size <= SEUIL || !window.DataTransfer || !window.HTMLCanvasElement) return Promise.resolve(false);
    enPrep = true;
    return decoder(f).then(function (im) {
      var w = im.width, h = im.height, r = Math.min(1, COTE_MAX / Math.max(w, h));
      var cv = document.createElement("canvas");
      cv.width = Math.round(w * r); cv.height = Math.round(h * r);
      var cx = cv.getContext("2d");
      cx.fillStyle = "#fff"; cx.fillRect(0, 0, cv.width, cv.height);
      cx.drawImage(im, 0, 0, cv.width, cv.height);
      if (im.close) im.close();
      return new Promise(function (ok) { cv.toBlob(ok, "image/jpeg", 0.9); });
    }).then(function (b) {
      if (!b || b.size >= f.size) return false;
      var nom = f.name.replace(/\.[^.]+$/, "") + ".jpg";
      var nf = new File([b], nom, { type: "image/jpeg", lastModified: Date.now() });
      var dt = new DataTransfer();
      dt.items.add(nf);
      champ.files = dt.files;
      return !!(champ.files && champ.files[0] && champ.files[0].size === nf.size);
    }).catch(function () { return false; }).then(function (fait) { enPrep = false; etat(); return fait; });
  }

  // Message fixe pendant l envoi : seul retour visible pendant que le fichier monte.
  function bandeauEnvoi(texte) {
    var e = document.getElementById("abn-envoi-photo");
    if (!texte) { if (e) e.remove(); return; }
    if (!e) {
      e = document.createElement("div");
      e.id = "abn-envoi-photo";
      e.setAttribute("role", "status");
      e.style.cssText = "position:fixed;left:12px;right:12px;bottom:84px;z-index:2147483000;max-width:520px;margin:0 auto;" +
        "padding:12px 14px;border-radius:6px;background:#1f3a2c;color:#fff;font-size:15px;line-height:1.4;" +
        "box-shadow:0 2px 10px rgba(0,0,0,.25)";
      document.body.appendChild(e);
    }
    e.textContent = texte;
    clearTimeout(e._t);
    e._t = setTimeout(function () { bandeauEnvoi(""); }, 120000);
  }
  window.addEventListener("pagehide", function () { bandeauEnvoi(""); });
  // Erreur d ajout affichee par le theme : on retire le bandeau pour ne pas masquer le message.
  new MutationObserver(function () {
    var er = document.querySelector(".product-form__error-message-wrapper:not([hidden])");
    if (er && document.getElementById("abn-envoi-photo")) bandeauEnvoi("");
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["hidden"] });

  function leChamp() {
    // Priorite au champ du theme : c est le seul que le formulaire d achat sait envoyer.
    return document.querySelector('input[type="file"][name="properties[Your photo]"]:not([data-abn-miroir])') ||
      document.querySelector('input[type="file"][name^="properties["]:not([data-abn-miroir])');
  }
  function leForm(champ) {
    return (champ && champ.closest('form[action*="/cart/add"]')) ||
      document.querySelector('form[action*="/cart/add"]');
  }
  function laBoite(champ) {
    return champ.closest(".selector-wrapper") || champ.parentElement;
  }

  function alerte(champ) {
    var e = document.getElementById("abn-photo-alerte");
    if (e) return e;
    e = document.createElement("p");
    e.id = "abn-photo-alerte";
    e.setAttribute("role", "alert");
    e.style.cssText = "display:none;margin:8px 0 0;padding:10px 12px;border-radius:6px;" +
      "background:#fdecea;color:#9b1c1c;font-size:15px;line-height:1.35;font-weight:600";
    e.textContent = ERREUR;
    laBoite(champ).appendChild(e);
    return e;
  }

  function confirmation(champ) {
    var e = document.getElementById("abn-photo-ok");
    if (e) return e;
    e = document.createElement("p");
    e.id = "abn-photo-ok";
    e.style.cssText = "display:none;margin:8px 0 0;padding:8px 12px;border-radius:6px;" +
      "background:#e7f6ec;color:#0f5132;font-size:14px;line-height:1.35;font-weight:600";
    laBoite(champ).appendChild(e);
    return e;
  }

  // Bouton d achat grise tant que la photo manque (audit du 19/09, constat 01-9) : avant, il avait
  // exactement la meme allure avant et apres l envoi. Il reste cliquable, sinon le message
  // « Pick your photo first » ne s afficherait plus.
  function etat() {
    var champ = leChamp();
    var vide = !!(champ && champ.required && !(champ.files && champ.files.length));
    document.documentElement.classList.toggle("abn-sans-photo", vide);
    if (vide && !document.getElementById("abn-sans-photo-css")) {
      var st = document.createElement("style");
      st.id = "abn-sans-photo-css";
      st.textContent = 'html.abn-sans-photo form[action*="/cart/add"] [name="add"],' +
        'html.abn-sans-photo .shopify-payment-button__button,' +
        'html.abn-sans-photo #abn-msticky-btn{opacity:.5;filter:grayscale(.6);cursor:not-allowed}';
      document.head.appendChild(st);
    }
  }
  document.addEventListener("change", function (ev) {
    if (ev.target && ev.target.type === "file") etat();
  }, true);

  // Deux champs fichier cohabitaient sur /products/custom-kits : celui de l app (BCPO,
  // properties[Upload a File:], dans un formulaire sans bouton d ajout) et celui du theme
  // (properties[Your photo]). habiller() renommait les DEUX en « Your photo » : le client qui
  // remplissait le bas, celui marque « (required) », ne partait jamais au panier. Mesure du
  // 20/09 a 390 px et 1280 px : champ du bas seul rempli => 2 taps avales, panier 0.
  // On ne laisse qu un champ a l ecran et on desarme le required de l autre, sinon la
  // validation native bute sur un champ obligatoire masque.
  function masquerDoublons(champ) {
    var tous = document.querySelectorAll('input[type="file"][name^="properties["]');
    for (var i = 0; i < tous.length; i++) {
      var e = tous[i];
      if (e === champ || e.hasAttribute("data-abn-miroir")) continue;
      e.required = false;
      e.removeAttribute("required");
      var b = e.closest(".selector-wrapper") || e.parentElement;
      if (b && b.getAttribute("data-abn-doublon") !== "1") {
        b.setAttribute("data-abn-doublon", "1");
        b.style.setProperty("display", "none", "important");
      }
    }
  }

  function habiller() {
    etat();
    var champ = leChamp();
    masquerDoublons(champ);
    if (!champ || champ.getAttribute("data-abn-net")) return true;
    champ.setAttribute("data-abn-net", "1");

    if (!champ.getAttribute("accept")) champ.setAttribute("accept", FORMATS);

    // L app ecrit aria-labeledby (attribut inexistant, faute de frappe pour aria-labelledby) vers
    // un id aleatoire : le champ n a donc aucun nom accessible. On retire l attribut mort et on nomme.
    champ.removeAttribute("aria-labeledby");
    if (!champ.getAttribute("aria-label")) champ.setAttribute("aria-label", LIBELLE);

    // l app sort « Upload a File:: » ; on remet un intitule lisible
    var boite = laBoite(champ);
    if (boite) {
      var marcheur = document.createTreeWalker(boite, NodeFilter.SHOW_TEXT, null);
      var noeud;
      while ((noeud = marcheur.nextNode())) {
        if (/Upload a File:*/i.test(noeud.nodeValue)) {
          noeud.nodeValue = noeud.nodeValue.replace(/Upload a File:*/i, LIBELLE);
        }
      }
      if (!boite.querySelector(".abn-upload-aide")) {
        var aide = document.createElement("p");
        aide.className = "abn-upload-aide";
        aide.textContent = AIDE;
        aide.style.cssText = "margin:.35rem 0 0;font-size:max(1.15rem,12px);line-height:1.4;opacity:.8;";
        boite.appendChild(aide);
      }
      alerte(champ);
      confirmation(champ);
    }

    champ.addEventListener("change", function () {
      var f0 = champ.files && champ.files.length ? champ.files[0] : null;
      if (f0 && f0.size > SEUIL) {
        var c0 = confirmation(champ);
        c0.textContent = t("prep");
        c0.style.display = "block";
        alerte(champ).style.display = "none";
      }
      alleger(champ, f0).then(function () { verifier(); });
    });
    function verifier() {
      var ok = champ.files && champ.files.length;
      var f = ok ? champ.files[0] : null;
      if (f && f.size > MAX_OCTETS) {
        champ.value = "";
        etat(); // l ecouteur de capture a deja tourne avec l ancien fichier, il faut regriser
        var trop = alerte(champ);
        trop.textContent = t("tooBig", { mb: Math.round(f.size / 1048576) });
        trop.style.display = "block";
        confirmation(champ).style.display = "none";
        return;
      }
      alerte(champ).style.display = "none";
      champ.style.outline = "";
      var c = confirmation(champ);
      if (ok) {
        c.textContent = t('attached', { name: champ.files[0].name });
        c.style.display = "block";
      } else {
        c.style.display = "none";
      }
    }
    return true;
  }

  // Ce qui flotte en haut de l ecran et mangerait la cible du defilement. Le bandeau de
  // consentement natif Shopify se pose en haut en mobile : mesure du 13/09 a 390 px,
  // #shopify-pc__banner occupe 0,92,390,225 en z-index 2000000. Un decalage fige a 140 px
  // deposait le champ ET le message dessous, donc invisibles pour qui n a pas encore repondu
  // au bandeau, c est-a-dire tout visiteur arrive par une publicite.
  function hautOccupe() {
    var h = 0;
    var tous = document.querySelectorAll("body *");
    for (var i = 0; i < tous.length; i++) {
      var e = tous[i];
      var s = getComputedStyle(e);
      if (s.position !== "fixed" && s.position !== "sticky") continue;
      if (s.display === "none" || s.visibility === "hidden") continue;
      var r = e.getBoundingClientRect();
      if (r.height < 1 || r.width < 1) continue;
      if (r.top > 200 || r.bottom < 1) continue;
      if (r.bottom > h) h = r.bottom;
    }
    return Math.round(h);
  }

  function libre(champ) {
    var r = champ.getBoundingClientRect();
    if (r.height < 1) return true;
    var t = document.elementFromPoint(Math.round(r.left + r.width / 2), Math.round(r.top + r.height / 2));
    if (!t || t === champ || champ.contains(t) || t.contains(champ)) return true;
    return t.getBoundingClientRect().bottom <= r.top;
  }

  function signaler(champ) {
    var e = alerte(champ);
    e.textContent = ERREUR; // l alerte est partagee avec le message de taille, on la remet a son texte
    e.style.display = "block";
    champ.style.outline = "2px solid #d92d20";
    champ.style.outlineOffset = "3px";
    var y = champ.getBoundingClientRect().top + window.scrollY - Math.max(140, hautOccupe() + 24);
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: "smooth" });
    // Rattrapage apres arret du defilement : si quelque chose recouvre encore le champ,
    // on le repousse sous l obstacle plutot que de laisser l acheteur devant un ecran muet.
    setTimeout(function () {
      if (libre(champ)) return;
      var r = champ.getBoundingClientRect();
      var t = document.elementFromPoint(Math.round(r.left + r.width / 2), Math.round(r.top + r.height / 2));
      if (!t) return;
      window.scrollBy({ top: -(t.getBoundingClientRect().bottom - r.top + 24), behavior: "smooth" });
    }, 700);
  }

  function boutonDAchat(cible) {
    if (!cible || !cible.closest) return null;
    if (cible.closest("#abn-msticky-btn")) return cible.closest("#abn-msticky-btn");
    var b = cible.closest('button, input[type="submit"], [name="add"]');
    return estAchat(b) ? b : null;
  }

  // La barre collante est un <button type="button"> pose HORS du formulaire : son gestionnaire
  // ajoute au panier en AJAX sans passer par la validation native. On intercepte en capture.
  document.addEventListener("click", function (ev) {
    if (!boutonDAchat(ev.target)) return;
    var champ = leChamp();
    if (!champ || !champ.required) return;          // fiches standard : rien a bloquer
    if (champ.files && champ.files.length) {        // photo deja jointe
      if (enPrep) {                                 // reduction en cours : on attend une seconde
        ev.preventDefault();
        ev.stopImmediatePropagation();
        bandeauEnvoi(t("prep"));
        return;
      }
      bandeauEnvoi(t("sending", { mb: (champ.files[0].size / 1048576).toFixed(1).replace(".", /^(en|ja|ko|zh)/.test(langue()) ? "." : ",") }));
      return;
    }
    ev.preventDefault();
    ev.stopImmediatePropagation();
    habiller();
    signaler(champ);
    setTimeout(function () {
      // La bulle native double le message ABN et le recouvre : mesure du 13/09 a 390 px, elle
      // se peint sur « Pick your photo first ». Elle reste sur desktop, ou elle a la place,
      // et ou elle est le seul retour que certains navigateurs donnent au clavier.
      if (window.innerWidth < 750) return;
      var f = leForm(champ);
      if (f && f.reportValidity) f.reportValidity();
    }, 900);
  }, true);

  document.addEventListener("DOMContentLoaded", habiller);
  var tours = 0;
  var minuteur = setInterval(function () {
    habiller();
    if (++tours > 60) clearInterval(minuteur);
  }, 400);
})();
